// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__6HIhp","footerContent":"footer_footerContent__UBXnX","footerIcon":"footer_footerIcon__UpqZ1","footerIconContainer":"footer_footerIconContainer__knRrY"};